"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import vueQr from "vue-qr";
let ProxyShareDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.showTips = true;
    this.link = "https://www.kuajingvs.com";
    this.showButton = false;
    this.timer = null;
    this.countDownTime = 5;
  }
  open(link) {
    return __async(this, null, function* () {
      try {
        this.link = link;
        this.countDown();
        this.dialog.visible = true;
      } catch (error) {
      }
    });
  }
  //倒计时5秒
  countDown() {
    this.timer = setInterval(() => {
      this.countDownTime--;
      if (this.countDownTime <= 0) {
        this.showButton = true;
        clearInterval(this.timer);
      }
    }, 1e3);
  }
  checkShowTips() {
    this.showTips = false;
  }
  close() {
    this.dialog.visible = false;
    this.showTips = true;
    this.showButton = false;
    this.countDownTime = 5;
  }
};
ProxyShareDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      vueQr
    }
  })
], ProxyShareDialog);
export {
  ProxyShareDialog as default
};
